<div class="drv-chart">
  <hero-chart *ngIf="chartData?.datasets?.length"
    [chartData]="chartData"
    [chartOptions]="chartOptions"></hero-chart>
</div>
<div class="drv-legend-container">
  <hero-panel-legends [items]="legend"></hero-panel-legends>
</div>